import { Component, ElementRef, Input, OnInit, ViewChild, EventEmitter, Output, AfterContentInit } from '@angular/core';
import { DepositoPix } from '../deposito-pix.model';
import { Licenca } from 'src/app/licenca/licenca.model';
import { MessageService } from 'primeng/api';
import { ExtratoService } from '../extrato.service';

@Component({
  selector: 'app-extrato-deposito-pix-cadastro',
  templateUrl: './extrato-deposito-pix-cadastro.component.html',
  styleUrls: ['./extrato-deposito-pix-cadastro.component.css']
})
export class ExtratoDepositoPixCadastroComponent implements OnInit, AfterContentInit {

  regExValor: RegExp = /[0123456789,]/;
  valor: string;
  blocked: boolean;

  @Input()
  depositoPix: DepositoPix;

  @Input()
  licenca: Licenca;

  @Output() onClose = new EventEmitter<void>();
  @Output() onPixCreated = new EventEmitter<DepositoPix>();

  @ViewChild('valorPix', { static: true })
  valorPixField: ElementRef;

  constructor(
    private extratoService: ExtratoService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.blocked = false;
  }

  ngAfterContentInit(): void {
    this.valor = this.depositoPix.valor.toFixed(2).replace('.', ',');
    console.log('depositoPix', this.depositoPix);
    console.log('valor', this.valor);
  }

  gerarQrCode() {
    this.blocked = true;
    console.log('Gerar QRCODE -> depositoPix:', this.depositoPix);

    // Valida empresaId
    if (this.depositoPix.empresaId === undefined || this.depositoPix.empresaId === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Empresa não selecionada.'
      });
      this.blocked = false;
      return;
    }

    // Valida licencaId
    if (this.depositoPix.licencaId === undefined || this.depositoPix.licencaId === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Conta não selecionada.'
      });
      this.blocked = false;
      return;
    }

    // Valida Valor do Pix
    if (this.valor === undefined || this.valor === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Valor inválido.'
      });
      this.valorPixField.nativeElement.focus();
      this.blocked = false;
      return;
    }
    let valorSplit = this.valor.split(',');
    if (valorSplit.length > 2) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Valor inválido.'
      });
      this.valorPixField.nativeElement.focus();
      this.blocked = false;
      return;
    }
    if (valorSplit.length === 2 && valorSplit[1].length > 2) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Valor com mais de 2 digitos decimais.'
      });
      this.valor = `${valorSplit[0]},${valorSplit[1].substring(0, 2)}`;
      this.valorPixField.nativeElement.focus();
      this.blocked = false;
      return;
    }
    this.depositoPix.valor = parseFloat(this.valor.replace(',', '.'));
    if (this.depositoPix.valor === undefined || this.depositoPix.valor === null || Number.isNaN(this.depositoPix.valor) || this.depositoPix.valor <= 0.00) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção!',
        detail: 'Valor indefinido.'
      });
      this.valorPixField.nativeElement.focus();
      this.blocked = false;
      return;
    }

    console.log('Gerar QRCODE -> POST depositoPix:', this.depositoPix);
    this.extratoService.postDepositoPix(this.depositoPix).subscribe(
      result => {
        this.depositoPix = result;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'PIX gerado com sucesso.'
        });
        this.onPixCreated.emit(result);
        this.blocked = false;
      },
      error => {
        console.log('Error :', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro ao gerar PIX!',
          detail: error.error.msg
        });
        this.valorPixField.nativeElement.focus();
        this.blocked = false;
      }
    );

    console.log('Gerar QRCODE -> depositoPix:', this.depositoPix);
  }

  fechar() {
    this.onClose.emit();
  }

}
